function isAndroidOpera () {
  return window.navigator.userAgent.indexOf('OPR') !== -1;
}

export default isAndroidOpera;